import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "C:/Users/Sonish Maharjan/Desktop/texpress/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`Texpress is an open-source project that provides a project setup for using `}<strong parentName="p">{`ExpressJS`}</strong>{` with `}<strong parentName="p">{`Typescript`}</strong>{`. It is designed to simplify the development process and make it easier to create web applications using these two technologies. With its built-in apps and packages, Texpress is modular and flexible, making it easy to get started with `}<strong parentName="p">{`ExpressJS`}</strong>{` and `}<strong parentName="p">{`Typescript`}</strong>{`, allowing developers to easily customize and extend the project as needed.`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul">
        <h3 parentName="li" {...{
          "id": "turborepo-integrated-monorepo-architecture"
        }}><strong parentName="h3">{`Turborepo Integrated Monorepo Architecture:`}</strong></h3>
        {`Texpress uses a monorepo architecture to manage the codebase, making it easier to share code between different apps and packages. Texpress uses TurboRepo, a tool for managing monorepos, to streamline the development process and improve code organization.`}</li>
      <li parentName="ul">
        <h3 parentName="li" {...{
          "id": "built-in-apps"
        }}><strong parentName="h3">{`Built-in Apps:`}</strong></h3>
        {`Texpress includes several built-in apps`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`CMS App`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`CMS`}</inlineCode>{` app included with Texpress provides an admin panel for managing content and data for your web application.`}</li>
          <li parentName="ul"><strong parentName="li">{`API App`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`API`}</inlineCode>{` app included with Texpress provides a RESTful API to be consumed by the frontend of your web application.`}</li>
          <li parentName="ul"><strong parentName="li">{`Queue Consumer`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`queue consumer`}</inlineCode>{` included with Texpress allows you to easily process messages from RabbitMQ queues, providing a scalable way to handle asynchronous tasks.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <h3 parentName="li" {...{
          "id": "built-in-packages"
        }}><strong parentName="h3">{`Built-in Packages:`}</strong></h3>
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Core`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`core`}</inlineCode>{` package included with Texpress provides the foundational components of the framework, such as middleware, routing, and request/response handling.`}</li>
          <li parentName="ul"><strong parentName="li">{`Shared`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`shared`}</inlineCode>{` package included with Texpress provides a common library of entities, utilities, and other shared code that can be used across different Texpress apps and packages.`}</li>
          <li parentName="ul"><strong parentName="li">{`RabbitMQ`}</strong><br parentName="li"></br>
            {`The `}<inlineCode parentName="li">{`rabbitmq`}</inlineCode>{` package included with Texpress provides a RabbitMQ client for using queues, with built-in producers, consumers, and RabbitMQ clients. It makes it easy to integrate messaging into your web application, providing a scalable way to handle asynchronous tasks.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Designed to simplify developing complex applications with a solid foundation.
Ideal for developers who are familiar with these technologies, as well as those who are looking to learn and explore new technologies.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      